import { Tooltip } from "@material-ui/core"
import { TooltipULStyles } from "./styles";

type PaymentMethodTooltipProps = {
    children: JSX.Element
}

export const PaymentMethodTooltip = ({ children }: PaymentMethodTooltipProps) => {

    const ULStyles = TooltipULStyles();

    return <Tooltip
        title={
            <ul className={ULStyles.root}>
                <li>ChargebeeStripe =&gt; cb_stripe</li>
                <li>ChargebeePaypal =&gt; cb_paypal</li>
                <li>ChargebeeApplePay =&gt; cb_appl_pay</li>
                <li>ChargebeeGooglePay =&gt; cb_ggl_pay</li>
                <li>Stripe =&gt; stripe</li>
                <li>Paypal =&gt; paypal</li>
            </ul>
        }
    >
        {children}
    </Tooltip>
}
